"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplePlus = void 0;
const react_1 = __importDefault(require("react"));
const SimplePlus = ({ size, color, outline }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.5 0C23.567 0 22 1.01754 22 2.27273V47.7273C22 48.9825 23.567 50 25.5 50C27.433 50 29 48.9825 29 47.7273V2.27273C29 1.01753 27.433 0 25.5 0Z", fill: color || '#25CFBB' }),
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M-1.31134e-07 25C-5.87107e-08 26.6569 1.01754 28 2.27273 28L47.7273 28C48.9825 28 50 26.6569 50 25C50 23.3431 48.9825 22 47.7273 22L2.27273 22C1.01753 22 -2.03558e-07 23.3431 -1.31134e-07 25Z", fill: color || '#25CFBB' })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_8717_34869" },
                react_1.default.createElement("rect", { width: "50", height: "50", fill: "white" })))));
};
exports.SimplePlus = SimplePlus;
